import _slicedToArray from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useEffect } from "react";
import { useDrawerAnimation, useFadeTransition } from "../../../../shared/animation";
import { colors } from "../../../../shared/constants";
import * as Icons from "../../../Icons";
import { Tag } from "../../productLinks";
import MenuBadge from "./MenuBadge";
import * as S from "./styles";
import SubMenu from "./SubMenu";
export var ShopDrawerContent = function ShopDrawerContent(_ref) {
  var e = _ref.active,
      t = _ref.closeMenu,
      n = _ref.hasPartialPipLoad,
      a = _ref.mainPromo,
      o = _ref.onMenuItemClick,
      r = _ref.onSubMenuClose,
      l = _ref.onSubMenuOpen,
      i = _ref.productCategories,
      s = _ref.renderLinkAs,
      _ref$root = _ref.root,
      u = _ref$root === void 0 ? "" : _ref$root,
      c = _ref.topLevelLinks;

  var _useState = useState(Tag.None),
      _useState2 = _slicedToArray(_useState, 2),
      m = _useState2[0],
      d = _useState2[1],
      p = useDrawerAnimation(e),
      g = useFadeTransition(m !== Tag.None && e),
      k = useFadeTransition(m);

  useEffect(function () {
    e || d(Tag.None);
  }, [e]), useEffect(function () {
    m === Tag.None ? r && r() : l && l();
  }, [m]);

  var f = function f(e, t) {
    var n = null == i ? void 0 : i.find(function (t) {
      return t && t.slug === e;
    });
    o && o("Site Nav (Desktop) - ".concat(null == n ? void 0 : n.displayName, " - ").concat(t));
  },
      E = function E(e, t) {
    return function () {
      return function (e, t) {
        return function () {
          e === (null == t ? void 0 : t.slug) ? d(Tag.None) : (d(null == t ? void 0 : t.slug), o && o("Site Nav (Desktop) - ".concat(t.displayName)));
        };
      }(e, t)();
    };
  },
      R = function R(e) {
    o && o("Site Nav (Desktop) - Filtered PIP Link - ".concat(e.categoryName)), t();
  };

  return React.createElement(React.Fragment, null, p(function (e, n) {
    return n ? React.createElement(S.DrawerPrimaryContent, {
      style: e,
      "data-testid": "desktop-menu-drawer-shop"
    }, null == i ? void 0 : i.map(function (e, t) {
      return React.createElement(React.Fragment, {
        key: "".concat(e.slug, "-").concat(t)
      }, React.createElement(S.MenuButton, {
        active: m === e.slug,
        onClick: E(m, e)
      }, React.createElement(S.MenuButtonContainer, null, e.displayName, e.badge ? React.createElement(MenuBadge, {
        text: e.badge,
        backgroundColor: colors.teal4
      }) : null)));
    }), React.createElement(S.ExitMenuLink, {
      href: c.shopAll.url,
      as: s || void 0,
      onClick: t
    }, c.shopAll.label, s ? React.createElement(Icons.RightArrow, null) : void 0), a && React.createElement(S.SubMenuSectionWrapper, null, React.createElement(S.PromoCard, Object.assign({}, a)))) : null;
  }), g(function (e, t) {
    return t ? React.createElement(S.DrawerSecondaryContent, {
      style: e,
      active: m !== Tag.None
    }, k(function (e) {
      return React.createElement(S.SubmenuContentWrapper, {
        style: e
      }, React.createElement(SubMenu, {
        key: "submenu-".concat(m),
        categoryInfo: (t = m, null == i ? void 0 : i.filter(function (e) {
          return function (_ref2) {
            var t = _ref2.slug;
            return t === e;
          };
        }(t))[0]),
        handleSubLinkClick: f,
        renderLinkAs: s,
        handleFilteredPipLinkClick: R,
        hasPartialPipLoad: n,
        root: u
      }));
      var t;
    })) : null;
  }));
};